import { ToastifyService, authService } from "../services";
import { GLOBAL_STATUS } from "./global-enums";
import { roles, serverResponseConstants } from "../constants/index";
import { viewPathConstants } from "../constants/global.constants";
import { clearUserData } from "./utility-functions";
import store from "../redux/store";
import { logout } from "../redux/actions/auth.action";

//Destructing constants
const {
  NETWORK_ERROR,
  SERVER_ISSUE,
  UNAUTHORIZE_ACCESS,
  SOMETHING_WENT_WRONG,
} = serverResponseConstants;

const { DEFAULT_PATH } = viewPathConstants;

//Retrieves all error messages from an object of errors.
function allErrorMessages(errors) {
  let errorMessages = [];
  // eslint-disable-next-line
  Object.keys(errors).forEach((key) => {
    errorMessages.push(errors[key]);
  });
  return errorMessages;
}

//Function to handle http response from server and perform action accordingly
function handleHTTPResponses(httpResponse) {
  let errorMessages = [];
  if (httpResponse) {
    const { message } = httpResponse.data;
    if (message === NETWORK_ERROR) {
      errorMessages.push(SERVER_ISSUE);
      return Promise.reject(errorMessages);
    }
    if (message === UNAUTHORIZE_ACCESS) {
      clearUserData();
      store.dispatch(logout());
      window.history.replaceState(null, null, viewPathConstants.DEFAULT_PATH);
    }
    const responseStatus = httpResponse.status;
    if (responseStatus !== GLOBAL_STATUS.SUCCESS) {
      // if (
      //   responseStatus === GLOBAL_STATUS.UNAUTHORIZED ||
      //   responseStatus === GLOBAL_STATUS.FORBIDDEN
      // ) {
      //   ToastifyService.showError(UNAUTHORIZE_ACCESS);
      //   setTimeout(() => {
      //     authService.logout().then(() => window.history.replaceState(null, null, DEFAULT_PATH));
      //   }, 1000);
      // }
      if (httpResponse.data.errors) {
        errorMessages = allErrorMessages(httpResponse.data.errors);
      }
      errorMessages.unshift(message);
      errorMessages = errorMessages.filter((x) => x);
      return Promise.reject(errorMessages);
    }
    return httpResponse;
  }
  errorMessages.push(SERVER_ISSUE);
  return Promise.reject(errorMessages);
}

//Function to handle action by server response text
function handleResponseByStatus(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (response.status === GLOBAL_STATUS.UNAUTHORIZED) {
      // auto logout if 401 response returned from api
      clearUserData();
      store.dispatch(logout());
      window.history.replaceState(null, null, viewPathConstants.DEFAULT_PATH);
    }

    const error = data?.message || response.statusText;
    return Promise.reject(error);
  });
}

//Handles server response
function handleServerResponse(response) {
  const { status, message, errors = [], data, page, pageData } = response;

  if (status === GLOBAL_STATUS.SUCCESS) {
    if (data.payload && data.message) {
      return { payload: data.payload, message: data.message };
    }
    return (
      data.payload ??
      data.message ?? { page: data.page, pageData: data.pageData }
    );
  }
  const Msg = () => (
    <div>
      <h4 className="m-0">{message || SOMETHING_WENT_WRONG}</h4>
      {Object.keys(errors).map((key) => (
        <div key={key}>{errors[key]}</div>
      ))}
    </div>
  );
  return Promise.reject(Msg);
}

const responseHandler = {
  handleHTTPResponses,
  handleResponseByStatus,
  handleServerResponse,
};

export default responseHandler;
